export const contracts = ({ contracts }) => contracts
export const contract = ({ contract }) => contract
export const contractPlans = ({ contractPlans }) => contractPlans
export const filterContracts = ({ filterContracts }) => filterContracts
export const filteredPlans = ({ filteredPlans }) => filteredPlans



// WEBPACK FOOTER //
// ./src/app/pages/contracts/vuex/getters.js